import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Collapse,
  Box
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";

const drawerWidth = 150;

function SidebarMenu() {
  const location = useLocation();
  const [openDashboard] = useState(true);

  const SidebarSubMenu = ({ to, icon, label }) => {
    const isSelected = location.pathname === to;

    return (
      <NavLink to={to} style={{ textDecoration: "none", color: "inherit" }}>
        <ListItemButton
          selected={isSelected}
          sx={{
            pl: 2,
            "&.Mui-selected": {
              backgroundColor: "#e3f2fd",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "#bbdefb",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 32,
              color: isSelected ? "#1976d2" : "inherit",
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="body2"
                sx={{
                  fontSize: 9,
                  whiteSpace: "pre-line",
                  fontWeight: isSelected ? "bold" : "normal",
                  color: isSelected ? "#1976d2" : "inherit",
                }}
              >
                {label}
              </Typography>
            }
          />
        </ListItemButton>
      </NavLink>
    );
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      <List disablePadding>
        {/* 대시보드 (상위 메뉴) */}
        <ListItemButton selected={location.pathname === "/"}>
          <ListItemIcon sx={{ minWidth: 36 }}>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="대시보드"
            sx={{ "& .MuiListItemText-primary": { fontSize: 12 } }}
          />
          {openDashboard ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        {/* 대시보드 하위 메뉴 */}
        <Collapse in={openDashboard} timeout="auto" unmountOnExit>
          <Box sx={{ borderLeft: "2px solid #e0e0e0", ml: 2 }}>
            <List component="div" disablePadding>
              <SidebarSubMenu
                to="/dashboard/real-category-rank-trend"
                icon={<CompareArrowsOutlinedIcon fontSize="small"/>}
                label={`커머스별\n상품순위 비교`}
              />
              <SidebarSubMenu
                to="/dashboard/rank-trend-commerce"
                icon={<StorefrontOutlinedIcon fontSize="small" />}
                label={`상품순위변동추이\n(커머스별 10위)`}
              />
              <SidebarSubMenu
                to="/dashboard/rank-trend-o"
                icon={<TrendingUpIcon fontSize="small" />}
                label={`상품순위변동추이\n(올리브영 100위)`}
              />
            </List>
          </Box>
        </Collapse>
      </List>
    </Drawer>
  );
}

export default SidebarMenu;
